<template>
	<div>
		<div style="padding:15px 20px;font-size:16px;font-weight:bold;">布局大小</div>
		<div style="padding:0px 20px;">
			<el-dropdown trigger="click" @command="handleSetSize">
				<el-dropdown-item v-for="item of sizeOptions" :key="item.value" :disabled="size===item.value" :command="item.value">
					{{item.label}}
				</el-dropdown-item>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				sizeOptions: [{
						label: 'Default',
						value: 'default'
					},
					{
						label: 'Medium',
						value: 'medium'
					},
					{
						label: 'Small',
						value: 'small'
					},
					{
						label: 'Mini',
						value: 'mini'
					}
				]
			}
		},
		computed: {
			size() {
				return this.$store.getters.size
			}
		},
		methods: {
			handleSetSize(size) {
				this.$ELEMENT.size = size
				this.$store.dispatch('app/setSize', size)
				this.refreshView()
				this.$message({
					message: 'Switch Size Success',
					type: 'success'
				})
			},
			refreshView() {
				// In order to make the cached page re-rendered
				this.$store.dispatch('tagsView/delAllCachedViews', this.$route)

				const {
					fullPath
				} = this.$route

				this.$nextTick(() => {
					this.$router.replace({
						path: '/redirect' + fullPath
					})
				})
			}
		}

	}
</script>
<style scoped>
	.el-dropdown {
		width: 100%;
		text-align: center;

	}

	.el-dropdown-menu__item {
		margin: 10px 0px;
		background-color: #F4F4F5;
	}
</style>
